var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6832 7.33333V19.5556H5.11175V7.33333H17.6832ZM15.326 0H7.46889L5.89746 1.22222H0.397461V3.66667H22.3975V1.22222H16.8975L15.326 0ZM20.826 4.88889H1.96889V19.5556C1.96889 20.9 3.38318 22 5.11175 22H17.6832C19.4117 22 20.826 20.9 20.826 19.5556V4.88889Z",
    fill: "#FF3152"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8e35bbef3768835497b5c456bc3ace10.svg";
export { ForwardRef as ReactComponent };